import React from 'react';

export function SkillViewBasicDetails({ skill }) {
  return (
    <table className="project-summary__info">
      <tbody>
        {/*<tr>
                <th>Name</th>
                <td>{skill?.name}</td>
            </tr>*/}
        <tr>
          <th>Description</th>
          <td>{skill?.description}</td>
        </tr>
      </tbody>
    </table>
  );
}
